import api from '../services/api';
import swal from 'sweetalert2';
import AdminApi from "../services/api";
import Loc from "../services/localization";
import VueQrcode from 'vue-qrcode-component';

/* init */
const AdminApiService = new AdminApi()
const LocService = new Loc()
import  Plyr  from 'vue-plyr';



export default {

    props: ['show', 'item'],

    data() {
        return {
            locale: LocService,
            title: '',
            iFrameView: false,
            videoView: false,
            iFrameUrl: null,
            videoFile: null,
            selectedItem: null,
            fileExtensions: ['mp4', 'webm', 'ogg'],
            plyrOptions: {
                autoplay: true,
                controls: ['play', 'progress', 'current-time', 'mute', 'fullscreen'],
                sources: [
                    {
                        src: 'https://file-examples.com/storage/fefcab211666f32e693a865/2017/04/file_example_MP4_480_1_5MG.mp4',
                        type: 'video/mp4',
                    },
                ],
            },
        };
    },

    watch: {
        show: function (val, oldVal) {
            if (val) {
                this.selectedItem = this.item;
                this.title = this.item.name
                if (this.isVideoFile(this.selectedItem.videoUrl)) {
                    this.videoView = true;
                    this.videoView = this.selectedItem.videoUrl;
                } else {
                    this.iFrameView = true;
                    this.iFrameUrl = this.selectedItem.videoUrl;

                    const videoIframe = document.getElementById('videoIframe');

                    try{
                        if (videoIframe.requestFullscreen) {
                            videoIframe.requestFullscreen();
                        } else if (videoIframe.mozRequestFullScreen) { // Firefox
                            videoIframe.mozRequestFullScreen();
                        } else if (videoIframe.webkitRequestFullscreen) { // Chrome, Safari, and Opera
                            videoIframe.webkitRequestFullscreen();
                        } else if (videoIframe.msRequestFullscreen) { // IE/Edge
                            videoIframe.msRequestFullscreen();
                        }
                    }catch (e){}
                }
            }

        },
    },
    components: {Plyr},
    methods: {
        close() {
            this.$topnavbar.$emit('closePlayVideo')
            this.iFrameView = false;
                this.videoView = false;
                this.iFrameUrl = null;
                this.videoFile = null;
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile() {
            if (this.isMobile()) {
                return 'modal--medium'
            } else {
                return 'modal--medium'
            }
        },
        modalStyle() {
            if (this.isMobile()) {
                return 'color: white; background-color: #1C242D;'
            } else {
                return ''
            }
        },
        mainDivStyle() {
            if (this.isMobile()) {
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            } else {
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            }
        },
        tableStyle() {
            if (this.isMobile()) {
                return 'height: 400px !important;';
            }
            return 'height: 600px !important;';
        },
        isVideoFile: isVideoFile

    }
}

function isVideoFile(url) {
    const extension = url.split('.').pop().toLowerCase();
    return this.fileExtensions.includes(extension);
}


// WEBPACK FOOTER //
// ./src/modals/PlayVideoDialog.js